const RequestManual = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {
    console.log('handleManualQuestion',loginInfo)
    console.log('RequestManual - input:', input)
    console.log('RequestManual - filtermessages:', filtermessages)

    let prompt;
    if (loginInfo?.prompt?.manual?.prompt) {
        prompt = loginInfo.prompt.manual.prompt;
    } else {
        prompt = `あなたはマニュアルに対して質問に答えるRAGアシスタントです。
#ルール:
- ユーザーの【質問】に対して【テキスト】【過去履歴】を参考にして回答してください。
- 【過去の履歴】からユーザーの意図を理解してください。
- 【テキスト】【過去履歴】にないことは答えないでください。
- わかりやすく手順を箇条書きにしてください。`;
    }

    let filter = loginInfo.faqapi.manual.filter;

    let messages='';
    
    // inputが空の場合、filtermessagesから最新のユーザー入力を取得
    if (!input || input.trim() === '') {
        console.log('input is empty, trying to get from filtermessages');
        if (filtermessages && filtermessages.length > 0) {
            // 最新のユーザーメッセージを取得
            const userMessages = filtermessages.filter(m => m.sender === "user");
            if (userMessages.length > 0) {
                const latestUserMessage = userMessages[userMessages.length - 1];
                input = latestUserMessage.text || '';
                console.log('Retrieved input from filtermessages:', input);
            }
        }
    }
    
    input = input.replace(/<[^>]*>|\[画像情報\]/g, '');
    console.log('RequestManual - cleaned input:', input);


    const query = {
        search: input,
        top: 5,
        filter: '',
        select: "sub_category,category,title,content,text,answer,site_name,URL,site_icon,model,update_at,tag",
        vectorQueries: [
            { 
                kind: "text",
                text: input,
                k: 5,
                fields: "embedding"
            }
        ],
    queryType: "semantic",
    captions: "extractive",
    answers: "extractive|count-3",
    semanticConfiguration: "cosmosdb03-semantic-configuration",
    queryLanguage: "ja-JP"
    }

    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXXXXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        queryLanguage: "ja-JP",
        mode:mode,
        prompt:prompt,
        inputs:input
    };

    try {

        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                // choices配列が存在し、要素があるかチェック
                if (!dataObj.choices || dataObj.choices.length === 0) {
                    console.warn("choices array is empty or undefined:", dataObj);
                    continue;
                }
                // delta.contentが存在するかチェック
                if (!dataObj.choices[0].delta || !dataObj.choices[0].delta.content) {
                    continue;
                }
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "manual"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "manual", text: delta , mode: 'manual', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.log('Error',error)
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestManual;
